module.exports = __webpack_public_path__ + "c7389a03c85bc90e844966b2e2d6d635.svg";